import { useEffect } from "react";
import { Footer } from "@/components/site/Footer";
import { Header } from "@/components/site/Header";
import { SEO } from "@/components/site/SEO";
import { TemplateMarkupLayer } from "@/components/site/TemplateMarkupLayer";
import { useRevealObserver } from "@/hooks/useReveal";
import { school } from "@/data/schoolData";

export function SiteLayout({ children, title, description, path, faqItems, breadcrumbs, funnel = false }) {
  useRevealObserver();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [path]);
  useEffect(() => {
    const root = document.documentElement;
    const theme = school.branding || {};
    const values = { "--accent": theme.accentColor, "--action": theme.actionColor || theme.accentColor, "--accent-hover": theme.accentHoverColor, "--accent-ink": theme.accentInkColor };
    Object.entries(values).forEach(([name, value]) => value && root.style.setProperty(name, value));
    return () => Object.keys(values).forEach((name) => root.style.removeProperty(name));
  }, []);
  return <><SEO title={title} description={description} path={path} faqItems={faqItems} breadcrumbs={breadcrumbs} /><TemplateMarkupLayer enabled={Boolean(path)} /><Header minimal={funnel} /><main className={funnel ? "funnel-main" : undefined}>{children}</main><Footer minimal={funnel} /></>;
}
